/**
 * Every outcome a repository can report, in the contract's vocabulary
 * (research R8). Screens switch on `kind`; only `failure` is worth a retry.
 */
export type DomainErrorKind =
  | 'notFound'
  /** A create repeating my own id whose listing I have since deleted (021). */
  | 'listingDeleted'
  | 'notYetAvailable'
  | 'notPermitted'
  /** No verified email or phone yet; the message says what to do (019 R7). */
  | 'verificationRequired'
  | 'invitationExpired'
  | 'nothingNew'
  | 'defaultCollection'
  | 'countChanged'
  | 'keepListChanged'
  | 'changeInProgress'
  | 'nameRequired'
  | 'invalid'
  | 'throttled'
  | 'notAuthenticated'
  | 'failure';

export type NameField = 'firstName' | 'lastName';

export class DomainError extends Error {
  constructor(
    readonly kind: DomainErrorKind,
    /** The contract's `detail`, shown wherever a screen shows a message. */
    message: string,
    /** `invalid` only: messages keyed by the domain field they belong to. */
    readonly fields: Record<string, string[]> = {},
    /** `nameRequired` only. */
    readonly missing: NameField[] = [],
  ) {
    super(message);
    this.name = 'DomainError';
  }

  get retryable(): boolean {
    return this.kind === 'failure';
  }
}

export function isDomainError(error: unknown, kind?: DomainErrorKind): error is DomainError {
  return error instanceof DomainError && (kind === undefined || error.kind === kind);
}
